import { all, takeLatest, takeEvery } from 'redux-saga/effects';
import { ADD, ROUTE_TO_SECOND_SCREEN } from "../redux/types/counter";
import { add, routeToSecondScreen } from './counter';
import {
  initApp, varifyOtp, getMyzone, validateUser, userLogs, loginAttempt,
  getStratergy, reportSend, getUserID, getAccountPerformance, getCapitalMovement,
  getCorporateAction, getDebitNote, getTaxaibleGain, getHoldingStatement, getAuditReportYears, getAuditReport, getAuditStratergy, bitalyLink,
  GetAccountStatement, GetMFAccountStatement, GetMFcapitalGainLoss, CheckAIFDITPan, CheckPMSDITPan, GetDITUserDetails
  , PMSgetAuditStratergy, GetAccountPerformanceGroupwis, getFractionLedger, pmsRealisedCapitalGainLossReport, CheckMFPanDist, myZoneNewData
} from './initApp';
import {
  getQueryCategory, getQuerySubCategory, RaiseQueryClientPMS, RaiseQueryClientMF, RaiseQuery, RaiseQueryClientAIF
  , ClientAIF, ClientMF, GetRaiseQuery
} from './raiseQuery';
import { pmsDistibutLogin, pmsGenerateOtp, resetPmsPassword } from './pmsSaga'
import {
  MYZONE, VALIDATE_USER, USER_LOG,
  LOGIN_ATTEMPT, INIT_APP, GET_STRATEGY, REPORT_SEND, USER_ID,
  GET_ACCOUNT_PERFORMANCE, GET_CAPITAL_MOVEMENT, GET_CORPORATE_ACTION, GET_DEBIT_NOTE,
  GET_TAXIBLE_GAIN, GET_HOLDING_STATEMENT, GET_AUDIT_REPORT_YEARS, GET_AUDIT_REPORT, GET_AUDIT_REPORT_STRATEGY, BITALY_LINK, GET_ACCOUNT_STATEMENT,
  GET_MF_ACCOUNT_STATEMENT, GET_MF_CAPITAL_GAIN_LOSS, CHECK_AIF_DIT_PAN, CHECK_PMS_DIT_PAN, PMS_GET_AUDIT_REPORT_STRATEGY,
  GET_ACCOUNT_PERFORMANCE_GROUP_WIS,
  GET_FRACTION_LEDGER,
  PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT,
  GET_MF_ACCOUNT_STATEMENT_INVESTOR,
  CHECK_MF_PAN_DIST,
  MYZONE_DATA
} from '../redux/types/initApp';
import { GET_DIT_USER_DETAILS } from "../redux/types/getDITUserDetails";
import {
  GET_QUERY_CATEGORY, GET_QUERY_SUB_CATEGORY, RAISE_QUERY_CLIENT_MF, RAISE_QUERY_CLIENT_PMS, RAISE_QUERY, RAISE_QUERY_CLIENT_AIF, CLIENT_AIF, CLIENT_MF,
  GET_RAISE_QUERY
} from '../redux/types/raiseQuery';
import { RaiseQueryAdminRole } from './addUser';
import { RAISE_QUERY_ADMIN_ROLE } from '../redux/types/addUser';
import { AUTHENTICATE_USER } from '../redux/types/authenticate';
import { authenticateUser, getDITAuthToken } from './authenticate';
import { AIF_LOGIN } from '../redux/types/aifLogin'
import { PMS_DIST_LOGIN, PMS_GENERATE_OTP, RESET_FORGOT_PASSWORD } from '../redux/types/pmsTypes'
// import { pmsDistibutLogin } from './pmsSaga'
import { AIFDistibutorLogin } from './aifLogin';
import { GET_DIT_PMS_DASHBOARD } from '../redux/types/dashboard'
import { GET_COMMISSION_TREND_YEAR_TRADE_DAY } from '../redux/types/getcommissiontrendYTD'
import { GET_PMS_DIT_ACTIVE_YEAR } from '../redux/types/getpmsditActiveYear'
import { GET_PMS_DIT_SALES_OVERVIEW_MTD } from '../redux/types/getpmsditSalesOverViewMTD'
import { GET_PMS_DIT_AUM_TREND_YTD } from '../redux/types/getpmsditAUMTrendYTD'
import { GET_PMS_DIT_INVENTOR_TREND_YTD } from '../redux/types/getpmsditInvestorTrendYTD'
import { GET_PMS_DIT_SALES_OVERVIEW_YTD } from '../redux/types/getpmsditSalesOverYTD';
import {
  GETPMSDITDashboard, GETPMSDITCommissionTrendYTD, GETPMSDITActiveYear, GETPMSDITSalesOverViewMTD, GETPMSDITAUMTrendYTD,
  GETPMSDITInvestorTrendYTD, GETPMSDITSalesOverViewYTD,
} from './dashboard';

import {
  aum, balanceSheet, bankBook, GetMFAccountStatementInvestor, pmsManagementFeesLedger, brokerLedger, clientInformation, getLedgerAccount,
  getExitLoadLedger, getIncomeExpenseStatment, pmsMovementOfCorpus, pmsPerformanceBasedFeesLedger, pmsProfitLoss,
  pmsUpfrontFeesPayableLedger, pmsTransactionStatementReport, pmsSecuritiesTransactionTax,
  getPerformanceFeesCalculation, getPMSWelcomeLetter, getCustodianFeesLedger, misMonth, misReports,accountPerMerger,
  onePager,
  getInvestmentDistributionStatement,
  cagrReport
} from './reports'

import {
  AUM, GET_BALANCE_SHEET, GET_BANK_BOOK, PMS_MANAGEMENT_FEES_LEDGER, GET_BROKER_LEDGER, GET_CLIENT_INFO, GET_LEDGER_ACCOUNT,
  GET_EXIT_LOAD_LEDGER, GET_INCOME_EXPENSE_STATEMENT, PMS_MOVEMENT_OF_CORPUS, PMS_PERFORMANCE_BASED_FEES_LEDGER,
  PMS_PROFIT_LOSS, PMS_UP_FRONT_FEES_PAYABLE_LEDGER, PMS_TRANSACTION_STATEMENT_REPORT, PMS_SECURITIES_TRANSACTION_TAX, PERFORMANCE_FEES_CALCULATION, GET_PMS_WELCOME_LETTER,
  GET_CUSTODIAN_FEES_LEDGER, GET_MIS_MONTH, MIS_REPORTS,ACC_PER_MERGER_REPORTS,ONEPAGER_REPORTS, GET_INVESTMENT_DISTRIBUTION_STATEMENT, CAGR_REPORT
} from '../redux/types/reports';
import { GETDITAUTHTOKEN } from '../redux/types/ditUserToken';
import { LOGOUT_TOKEN } from '../redux/types/init';
import { logout } from './logout';

import { ADD_REPORT_ISSUE, ADD_SUGGESTION, GET_DIT_REPORT_LIST, SUBMIT_DIT_REPORT, FILE_UPLOAD } from "../redux/types/ditReport";
import { getDitReportList, submitDitReport, addSuggestionData, addReportIssue, fileUpload } from './ditReport';


function* rootSaga() {
  yield all([
    takeLatest(INIT_APP, initApp),
    takeLatest(VALIDATE_USER, validateUser),
    takeLatest(MYZONE, getMyzone),
    takeLatest(USER_LOG, userLogs),
    takeLatest(AUTHENTICATE_USER, authenticateUser),
    takeLatest(LOGIN_ATTEMPT, loginAttempt),
    takeEvery(GET_STRATEGY, getStratergy),
    takeLatest(REPORT_SEND, reportSend),
    takeLatest(USER_ID, getUserID),
    takeLatest(MYZONE_DATA, myZoneNewData),
    takeEvery(GET_ACCOUNT_PERFORMANCE, getAccountPerformance),
    takeEvery(GET_CAPITAL_MOVEMENT, getCapitalMovement),
    takeEvery(GET_CORPORATE_ACTION, getCorporateAction),
    takeEvery(GET_DEBIT_NOTE, getDebitNote),
    takeEvery(GET_TAXIBLE_GAIN, getTaxaibleGain),
    takeEvery(GET_HOLDING_STATEMENT, getHoldingStatement),
    takeLatest(GET_AUDIT_REPORT_YEARS, getAuditReportYears),
    takeEvery(GET_AUDIT_REPORT, getAuditReport),
    takeLatest(GET_QUERY_CATEGORY, getQueryCategory),
    takeLatest(GET_QUERY_SUB_CATEGORY, getQuerySubCategory),
    takeLatest(RAISE_QUERY_CLIENT_MF, RaiseQueryClientMF),
    takeLatest(RAISE_QUERY_CLIENT_PMS, RaiseQueryClientPMS),
    takeLatest(RAISE_QUERY, RaiseQuery),
    takeLatest(GET_AUDIT_REPORT_STRATEGY, getAuditStratergy),
    takeLatest(RAISE_QUERY_CLIENT_AIF, RaiseQueryClientAIF),
    takeEvery(BITALY_LINK, bitalyLink),
    takeLatest(GET_ACCOUNT_STATEMENT, GetAccountStatement),
    takeLatest(CLIENT_AIF, ClientAIF),
    takeLatest(CLIENT_MF, ClientMF),
    takeLatest(GET_MF_ACCOUNT_STATEMENT, GetMFAccountStatement),
    takeLatest(GET_MF_CAPITAL_GAIN_LOSS, GetMFcapitalGainLoss),
    takeLatest(GET_RAISE_QUERY, GetRaiseQuery),
    takeLatest(RAISE_QUERY_ADMIN_ROLE, RaiseQueryAdminRole),
    takeLatest(AIF_LOGIN, AIFDistibutorLogin),
    takeLatest(RESET_FORGOT_PASSWORD, resetPmsPassword),
    takeLatest(PMS_DIST_LOGIN, pmsDistibutLogin),
    takeLatest(PMS_GENERATE_OTP, pmsGenerateOtp),
    takeLatest(GET_DIT_PMS_DASHBOARD, GETPMSDITDashboard),
    takeLatest(GET_COMMISSION_TREND_YEAR_TRADE_DAY, GETPMSDITCommissionTrendYTD),
    takeLatest(GET_PMS_DIT_ACTIVE_YEAR, GETPMSDITActiveYear),
    takeLatest(GET_PMS_DIT_SALES_OVERVIEW_MTD, GETPMSDITSalesOverViewMTD),
    takeLatest(GET_PMS_DIT_AUM_TREND_YTD, GETPMSDITAUMTrendYTD),
    takeLatest(GET_PMS_DIT_INVENTOR_TREND_YTD, GETPMSDITInvestorTrendYTD),
    takeLatest(GET_PMS_DIT_SALES_OVERVIEW_YTD, GETPMSDITSalesOverViewYTD),
    takeLatest(CHECK_PMS_DIT_PAN, CheckPMSDITPan),
    takeLatest(CHECK_AIF_DIT_PAN, CheckAIFDITPan),
    takeLatest(GET_DIT_USER_DETAILS, GetDITUserDetails),
    takeLatest(PMS_GET_AUDIT_REPORT_STRATEGY, PMSgetAuditStratergy),
    takeLatest(GET_ACCOUNT_PERFORMANCE_GROUP_WIS, GetAccountPerformanceGroupwis),

    takeEvery(GET_FRACTION_LEDGER, getFractionLedger),
    takeEvery(PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT, pmsRealisedCapitalGainLossReport),

    //common all report
    takeEvery(AUM, aum),
    takeEvery(GET_INVESTMENT_DISTRIBUTION_STATEMENT, getInvestmentDistributionStatement),
    takeEvery(GET_BALANCE_SHEET, balanceSheet),
    takeEvery(GET_BANK_BOOK, bankBook),
    takeEvery(PMS_MANAGEMENT_FEES_LEDGER, pmsManagementFeesLedger),
    takeEvery(GET_MF_ACCOUNT_STATEMENT_INVESTOR, GetMFAccountStatementInvestor),

    takeEvery(GET_BROKER_LEDGER, brokerLedger),
    takeEvery(GET_CLIENT_INFO, clientInformation),
    takeEvery(GET_LEDGER_ACCOUNT, getLedgerAccount),
    takeEvery(GET_EXIT_LOAD_LEDGER, getExitLoadLedger),
    takeEvery(GET_INCOME_EXPENSE_STATEMENT, getIncomeExpenseStatment),
    takeEvery(PMS_MOVEMENT_OF_CORPUS, pmsMovementOfCorpus),
    takeEvery(PMS_PERFORMANCE_BASED_FEES_LEDGER, pmsPerformanceBasedFeesLedger),
    takeEvery(PMS_PROFIT_LOSS, pmsProfitLoss),
    takeEvery(PMS_UP_FRONT_FEES_PAYABLE_LEDGER, pmsUpfrontFeesPayableLedger),
    takeEvery(PMS_TRANSACTION_STATEMENT_REPORT, pmsTransactionStatementReport),
    takeEvery(PMS_SECURITIES_TRANSACTION_TAX, pmsSecuritiesTransactionTax),
    takeEvery(PERFORMANCE_FEES_CALCULATION, getPerformanceFeesCalculation),
    takeEvery(GET_PMS_WELCOME_LETTER, getPMSWelcomeLetter),
    takeEvery(GET_CUSTODIAN_FEES_LEDGER, getCustodianFeesLedger),
    takeEvery(GET_MIS_MONTH, misMonth),
    takeEvery(MIS_REPORTS, misReports),
    takeEvery(CHECK_MF_PAN_DIST, CheckMFPanDist),
    takeEvery(GETDITAUTHTOKEN, getDITAuthToken),
    takeEvery(ACC_PER_MERGER_REPORTS, accountPerMerger),
    takeEvery(ONEPAGER_REPORTS, onePager),
    takeEvery(CAGR_REPORT, cagrReport),
    takeEvery(LOGOUT_TOKEN, logout),
    
    takeLatest(GET_DIT_REPORT_LIST, getDitReportList),
    takeLatest(SUBMIT_DIT_REPORT, submitDitReport),
    takeLatest(ADD_REPORT_ISSUE, addReportIssue),
    takeLatest(ADD_SUGGESTION, addSuggestionData),
    takeLatest(FILE_UPLOAD, fileUpload),
  ])
}
export default rootSaga;